export const LOAD_TENANTS_LIST_SUCCESSFULL = 'LOAD_TENANTS_LIST_SUCCESSFULL';
export const TENANTNAMES_LIST_SUCCESSFULL = 'TENANTNAMES_LIST_SUCCESSFULL';
export const USER_AUTH_SUCCESSFULL = 'USER_AUTH_SUCCESSFULL';
export const USER_AUTH_UNSUCCESSFULL = 'USER_AUTH_UNSUCCESSFULL';
export const LOAD_INITIAL_FACILITY_PLACES_SUCCESSFULL = 'LOAD_INITIAL_FACILITY_PLACES_SUCCESSFULL';
export const GET_SUCCESSFULL = 'GET_SUCCESSFULL';
export const POST_SUCCESSFULL = 'POST_SUCCESSFULL';
export const GET_USERROLE_PERMISSION = 'GET_USERROLE_PERMISSION';
export const GET_WORKORDERROLE_PERMISSION = 'GET_WORKORDERROLE_PERMISSION';
export const POST_PARAMS_SUCCESSFULL = 'POST_PARAMS_SUCCESSFULL';
export const SET_MANAGE_TENANT_ROUTE = 'SET_MANAGE_TENANT_ROUTE';
export const LOAD_TENANT_SUCCESSFULL = 'LOAD_TENANT_SUCCESSFULL';
export const SET_USER_ID = 'SET_USER_ID';
export const SET_USER_IDS = 'SET_USER_IDS';
export const SET_HOLIDAY_ID = 'SET_HOLIDAY_ID';
export const LOAD_VIEW_TENANT_SUCCESSFULL = 'LOAD_VIEW_TENANT_SUCCESSFULL';
export const UPDATE_FIELD = 'UPDATE_FIELD';
export const POST_TENANT_EMPLOYEE_DETAILS_SUCCESSFULL = 'POST_TENANT_EMPLOYEE_DETAILS_SUCCESSFULL';
export const PUT_TENANT_NORMAL_HOURS_SUCCESSFULL = 'PUT_TENANT_NORMAL_HOURS_SUCCESSFULL';
export const PUT_TENANT_AFTER_HOURS_SUCCESSFULL = 'PUT_TENANT_AFTER_HOURS_SUCCESSFULL';
export const PUT_TENANT_COMPANY_INFO_SUCCESSFULL = 'PUT_TENANT_COMPANY_INFO_SUCCESSFULL';
export const PUT_TENANT_ZONES_SUCCESSFULL = 'PUT_TENANT_ZONES_SUCCESSFULL';
export const PUT_METER_DETAILS_SUCCESSFULL = 'PUT_METER_DETAILS_SUCCESSFULL';
export const DELETE_METER_DETAILS_SUCCESSFULL = 'DELETE_METER_DETAILS_SUCCESSFULL';
export const GET_ZONES_LIST_SUCCESSFULL = 'GET_ZONES_LIST_SUCCESSFULL';
export const GET_BUILDINGS_LIST_SUCCESSFULL = 'GET_BUILDINGS_LIST_SUCCESSFULL';
export const GET_FAMILY_LIST_SUCCESSFULL = 'GET_FAMILY_LIST_SUCCESSFULL';
export const GET_POINTS_LIST_SUCCESSFULL = 'GET_POINTS_LIST_SUCCESSFULL';
export const GET_BUILDING_POINTS_LIST_SUCCESSFULL = 'GET_BUILDING_POINTS_LIST_SUCCESSFULL';
export const GET_UNITS_LIST_SUCCESSFULL = 'GET_UNITS_LIST_SUCCESSFULL';
export const GET_EQUIPMENT_OBJECT_LIST_SUCCESSFULL = 'GET_EQUIPMENT_OBJECT_LIST_SUCCESSFULL';
export const GET_MEMBERS_LIST_SUCCESSFULL = 'GET_MEMBERS_LIST_SUCCESSFULL';
export const GET_HOLIDAY_LIST_SUCCESSFUL = 'GET_HOLIDAY_LIST_SUCCESSFULL';
export const GET_DATALOG_VALUE_SUCCESSFULL = 'GET_DATALOG_VALUE_SUCCESSFULL';
export const GET_HOLIDAY_SUCCESSFUL = 'GET_HOLIDAY_SUCCESSFULL';
export const GET_BUILDINGS_DETAILS_SUCCESSFULL = 'GET_BUILDINGS_DETAILS_SUCCESSFULL';
export const POST_HOLIDAY_SUCCESSFULL = 'POST_HOLIDAY_SUCCESSFULL';
export const GET_USER_PREFERENCES_SUCCESSFULL = 'GET_USER_PREFERENCES_SUCCESSFULL';
export const GET_LABELS_BASED_ON_CULTURE_SUCCESSFULL = 'GET_LABELS_BASED_ON_CULTURE_SUCCESSFULL';
export const SET_TENANT_COMPANY_DETAILS = 'SET_TENANT_COMPANY_DETAILS';
export const SET_TENANT_ZONES_DETAILS = 'SET_TENANT_ZONES_DETAILS';
export const SET_TENANT_AFTERHOURS_DETAILS = 'SET_TENANT_AFTERHOURS_DETAILS';
export const SET_TENANT_NORMALHOURS_DETAILS = 'SET_TENANT_NORMALHOURS_DETAILS';
export const SET_TENANT_FIXEDCHARGES_DETAILS = 'SET_TENANT_FIXEDCHARGES_DETAILS';
export const SET_TENANT_EMPLOYEE_DETAILS = 'SET_TENANT_EMPLOYEE_DETAILS';
export const SET_INDIVIDUAL_METER_DETAILS = 'SET_INDIVIDUAL_METER_DETAILS';
export const SET_METER_DETAILS = 'SET_METER_DETAILS';
export const GET_ZONES_DETAILS_FOR_STATE_SUCCESSFULL = 'GET_ZONES_DETAILS_FOR_STATE_SUCCESSFULL';
export const GET_EMPLOYEE_REGULAREXPRESSION_SUCCESSFULL = 'GET_EMPLOYEE_REGULAREXPRESSION_SUCCESSFULL';
export const ADD_HOURS_PERIOD_MODAL = 'ADD_HOURS_PERIOD_MODAL';
export const GET_ZONES_BY_TENANT_ID = 'GET_ZONES_BY_TENANT_ID';
export const CLOSE_MODAL_POPUP = 'CLOSE_MODAL_POPUP';
export const CHANGE_VIEW_FACILITY = 'CHANGE_VIEW_FACILITY';
export const GET_TEMPERATURE_ADJUSTMENTS_SUCCESSFULL = 'GET_TEMPERATURE_ADJUSTMENTS_SUCCESSFULL';
export const GET_FACILITY_PLACES_SUCCESSFULL = 'GET_FACILITY_PLACES_SUCCESSFULL';
export const GET_EMPLOYEE_LIST_SUCCESSFULL = 'GET_EMPLOYEE_LIST_SUCCESSFULL';
export const LOGOUT_USER = 'LOGOUT_USER';
export const GET_FACILITY_REQUESTS_SUCCESSFULL = 'GET_FACILITY_REQUESTS_SUCCESSFULL';
export const GET_METERS_BY_TENANT_ID = 'GET_METERS_BY_TENANT_ID';
export const GET_DATALOG_METERS_OBJECTS = 'GET_DATALOG_METERS_OBJECTS';
export const GET_DATALOG_FOR_METERS_OBJECTS = 'GET_DATALOG_FOR_METERS_OBJECTS';
export const GET_METERS_DATALOG = 'GET_METERS_DATALOG';
export const GET_REQUESTS_SUCCESSFULL = 'GET_REQUESTS_SUCCESSFULL';
export const GET_COST_SUCCESSFULL = 'GET_COST_SUCCESSFULL';
export const GET_SELECTED_REQUEST_SUCCESSFULL = 'GET_SELECTED_REQUEST_SUCCESSFULL';
export const GET_PASTREQUESTS_SUCCESSFUL = 'GET_PASTREQUESTS_SUCCESSFUL';
export const GET_IS_LOGONNAME_EXISTS = 'GET_IS_LOGONNAME_EXISTS';
export const GET_TENANT_INVOICE_DETAILS_SUCCESSFUL = 'GET_TENANT_INVOICE_DETAILS_SUCCESSFUL';
export const GET_TENANT_AFTERHOURS_DETAILS_SUCCESSFUL = 'GET_TENANT_AFTERHOURS_DETAILS_SUCCESSFUL';
export const GET_FACILITY_ZONEDETAILS_SUCCESSFULL = 'GET_FACILITY_ZONEDETAILS_SUCCESSFULL';
export const GET_INOVICE_TEMPLATE = 'GET_INOVICE_TEMPLATE';
export const GET_FACILITY_IMAGE = 'GET_FACILITY_IMAGE';
export const GET_FACILITY_BACKGROUND_IMAGE = 'GET_FACILITY_BACKGROUND_IMAGE';
export const GET_INOVICE_LOGO = 'GET_INOVICE_LOGO';
export const POST_INOVICE_IMAGE = 'POST_INOVICE_IMAGE';
export const GET_TENANT_GENERATED_INVOICES_SUCCESSFUL = 'GET_TENANT_GENERATED_INVOICES_SUCCESSFUL';
export const DOWNLOAD_INVOICE_SUCCESSFUL = 'DOWNLOAD_INVOICE_SUCCESSFUL';
export const GET_EMPLOYEE_LOGIN_LOGO = 'GET_EMPLOYEE_LOGIN_LOGO';
export const GET_DISCOVERY_LIST = 'GET_DISCOVERY_LIST';
export const GET_BUILDINGS_DISCOVERED_LIST = 'GET_BUILDINGS_DISCOVERED_LIST';
export const GET_SERVER_ID = 'GET_SERVER_ID';
export const GET_LICENSE = 'GET_LICENSE';
export const GET_LICENSE_INFORMATION = 'GET_LICENSE_INFORMATION';
export const GET_LICENSED_CUSTOMER_INFORMATION = 'GET_LICENSED_CUSTOMER_INFORMATION';
export const GET_FEATURE_LICENSE_INFORMATION = 'GET_FEATURE_LICENSE_INFORMATION';
export const UPLOAD_STATUS = 'UPLOAD_STATUS';
export const UPLOAD_LICENSE_FILE_RESPONSE = 'UPLOAD_LICENSE_FILE_RESPONSE';
export const GET_USER_ROLE = 'GET_USER_ROLE';
export const GET_USER_LIST = 'GET_USER_LIST';
export const GET_USER_DETAILS = 'GET_USER_DETAILS';
export const SET_USER_DETAILS = 'SET_USER_DETAILS';
export const CLEAR_USER_DETAILS = 'CLEAR_USER_DETAILS';
export const GET_IS_USERNAME_EXISTS = 'GET_IS_USERNAME_EXISTS';
export const GET_TRANEUSER_DETAILS = 'GET_TRANEUSER_DETAILS';
export const ADD_NEW_BUILDINGS = 'ADD_NEW_BUILDINGS';
export const PASSWORD_EXPIRED = 'PASSWORD_EXPIRED';
export const SINGLE_SIGN_ON_FAILED = 'SINGLE_SIGN_ON_FAILED';
export const API_NOT_RESPONDING = 'API_NOT_RESPONDING';
export const GET_USERCHANGELOGS_SUCCESSFULL = 'GET_USERCHANGELOGS_SUCCESSFULL';
export const USER_FORBIDDEN = 'USER_FORBIDDEN';
export const USER_ERRORDETAILS = 'USER_ERRORDETAILS';
export const USER_ERRORRESET = 'USER_ERRORRESET';
export const ONPRIMISE_ERRORRESET = 'ONPRIMISE_ERRORRESET';
export const EULA_NOT_ACCEPTED = 'EULA_NOT_ACCEPTED';
export const PASSWORD_USED_IN_HISTORY_ERROR = 'PASSWORD_USED_IN_HISTORY_ERROR';
export const USER_ACTIVITY_DETAIL = 'USER_ACTIVITY_DETAIL';
export const GET_APPLICATION_VERSION = 'GET_APPLICATION_VERSION';
export const GET_COMMON_RESOURCE = 'GET_COMMON_RESOURCE'; 
export const GET_WORKORDERS_RESOURCE = 'GET_WORKORDERS_RESOURCE';
export const GET_TEMPERATURE_WIDGET_SUCCESSFULL = 'GET_TEMPERATURE_WIDGET_SUCCESSFULL';
export const POST_USER_LOG_TRANSACTION_SUCCESSFULL = 'POST_USER_LOG_TRANSACTION_SUCCESSFULL';
export const POST_TEMPERATURE_WIDGET_SUCCESSFULL = 'POST_TEMPERATURE_WIDGET_SUCCESSFULL';
export const GET_USER_INFO = 'GET_USER_INFO';
export const GET_SYSTEM_ADMIN_LABELS_BASED_ON_CULTURE_SUCCESSFULL = 'GET_SYSTEM_ADMIN_LABELS_BASED_ON_CULTURE_SUCCESSFULL';
export const GET_DMRESOURCES_LABELS_BASED_ON_CULTURE_SUCCESSFULL = 'GET_DMRESOURCES_LABELS_BASED_ON_CULTURE_SUCCESSFULL';
export const GET_DATAVIS_LABELS_BASED_ON_CULTURE_SUCESSFULL = 'GET_DATAVIS_LABELS_BASED_ON_CULTURE_SUCESSFUL';
export const GET_REPORTMGMT_LABELS_BASED_ON_CULTURE_SUCESSFULL = 'GET_REPORTMGMT_LABELS_BASED_ON_CULTURE_SUCESSFUL';
export const SET_ONPREMISE_DETAIL = 'SET_ONPREMISE_DETAIL';
export const SET_EQUIPMENT_SUMMARY_DETAIL = 'SET_EQUIPMENT_SUMMARY_DETAIL';
export const GET_ZONE_TIMEZONE_DETAIL = 'GET_ZONE_TIMEZONE_DETAIL';
export const GET_PRODUCT_FULLVERSION = 'GET_PRODUCT_FULLVERSION';
export const GET_DB_VERSION = 'GET_DB_VERSION';
export const GET_BUILDINGS_LIST = 'GET_BUILDINGS_LIST';
export const GET_TENANT_WORKORDER_LICENSE = 'GET_TENANT_WORKORDER_LICENSE';
export const GET_BUILDINGS_TIMEZONES_SUCCESSFULL = 'GET_BUILDINGS_TIMEZONES_SUCCESSFULL';
export const SET_RESET_PASSWORD_ERROR = 'SET_RESET_PASSWORD_ERROR';
export const SET_STATUS_LABELS_BASED_ON_CULTURE_SUCCESSFULL = 'SET_STATUS_LABELS_BASED_ON_CULTURE_SUCCESSFULL';
export const GET_INSTANCETYPE = 'GET_INSTANCETYPE';
export const GET_DEVICE_PANEL_DETAILS = 'GET_DEVICE_PANEL_DETAILS';

//Synchronize database
export const BUILDING_SYNCHRONIZATION = 'BUILDING_SYNCHRONIZATION';
export const GET_TRANE_USER = 'GET_TRANE_USER';
export const GET_TRANE_SITES = 'GET_TRANE_SITES';
export const TRANE_CONNECT_ERROR_STATUS = 'TRANE_CONNECT_ERROR_STATUS';

// Dashboards Constants

export const GET_DASHBOARDS_LIST = 'GET_DASHBOARDS_LIST';
export const GET_DASHBOARD_BY_ID_SUCCESSFUL = 'GET_DASHBOARD_BY_ID_SUCCESSFUL';
export const GET_DASHBOARD_BY_PATH_SUCCESSFUL = 'GET_DASHBOARD_BY_PATH_SUCCESSFUL';

//Workorder
export const GET_WORKORDER_SCHEDULE = ' GET_WORKORDER_SCHEDULE';
export const GET_WORKORDERLIST = 'GET_WORKORDERLIST';
export const GET_CLOSEDWORKORDERLIST = 'GET_CLOSEDWORKORDERLIST';
export const GET_WORKORDERDETAILS = 'GET_WORKORDERDETAILS';
export const GET_WORKORDER_BUILDINGS = 'GET_WORKORDER_BUILDINGS';
export const GET_WORKORDER_EQUIPMENTS = 'GET_WORKORDER_EQUIPMENTS';
export const GET_WORKORDER_BUILDING = 'GET_WORKORDER_BUILDING';
export const GET_WORKORDER_BUILDINGS_EQUIPMENTS = 'GET_WORKORDER_BUILDINGS_EQUIPMENTS';
export const GET_PM_BUILDINGS_EQUIPMENTS = 'GET_PM_BUILDINGS_EQUIPMENTS';
export const GET_TECHNICIANLIST = 'GET_TECHNICIANLIST';
export const GET_TECHNICIANDETAILS = 'GET_TECHNICIANDETAILS';
export const CHANGE_VIEW_WORKORDER_BUILDINGS = 'CHANGE_VIEW_WORKORDER_BUILDINGS';
export const CHANGE_VIEW_WORKORDER_TENANTS = 'CHANGE_VIEW_WORKORDER_TENANTS';
export const GET_STANDARD_FIELDS = 'GET_STANDARD_FIELDS';
export const WORKORDER_PREFERENCE_SUCCESSSFULL = 'WORKORDER_PREFERENCE_SUCCESSSFULL';
export const WORKORDER_USER_PREFERENCE_SUCCESSFUL = 'WORKORDER_USER_PREFERENCE_SUCCESSFUL';
export const TENANT_TO_ASSOCIATE = 'TENANT_TO_ASSOCIATE';
export const GET_TENANT_ASSOCIATION = 'GET_TENANT_ASSOCIATION';
export const GET_PREVENTATIVE_MAINTENANCE_STANDARD_FIELDS = 'GET_PREVENTATIVE_MAINTENANCE_STANDARD_FIELDS';
export const PREVENTATIVE_USER_PREFERENCE_SUCCESSFUL = 'PREVENTATIVE_USER_PREFERENCE_SUCCESSFUL';
export const PREVENTATIVE_PREFERENCE_SUCCESSSFULL = 'PREVENTATIVE_PREFERENCE_SUCCESSSFULL';
export const GET_MAILSETTING = 'GET_MAILSETTING';
export const GET_CUSTOM_FIELDS = 'GET_CUSTOM_FIELDS';
export const ADD_CUSTOM_CLOSE_MODAL_POPUP = 'ADD_CUSTOM_CLOSE_MODAL_POPUP';
export const ADD_TEMPLATE_CLOSE_MODAL_POPUP = 'ADD_TEMPLATE_CLOSE_MODAL_POPUP';
export const GET_PM_CUSTOM_FIELDS = 'GET_PM_CUSTOM_FIELDS';
export const GET_UNIQUEFILECOLLECTION = 'GET_UNIQUEFILECOLLECTION';
export const GET_WOSETUPMAILADDRESSES = 'GET_WOSETUPMAILADDRESSES';
export const GET_SERVICE_REQUEST_SETUP_DETAILS = 'GET_SERVICE_REQUEST_SETUP_DETAILS';
export const GET_WOFORM_CUSTOMFIELDS = 'GET_WOFORM_CUSTOMFIELDS';
export const GET_WOFORM_TENANTLISTS = 'GET_WOFORM_TENANTLISTS';

//WorkOrderReports
export const GET_ALL_WORKORDERREPORTSLIST = 'GET_ALL_WORKORDERREPORTSLIST';
export const GET_WORKORDERREPORTS_DETAILS = 'GET_WORKORDERREPORTS_DETAILS';

//HubManagement
export const GET_EXTERNALURI_TEMPLATE_DETAILS = 'GET_EXTERNALURI_TEMPLATE_DETAILS';
export const GET_NETWORKLIST_TEMPLATE_DETAILS = 'GET_NETWORKLIST_TEMPLATE_DETAILS';
export const GET_CERTIFICATELIST_TEMPLATE_DETAILS = 'GET_CERTIFICATELIST_TEMPLATE_DETAILS';
export const GET_NETWORKDETAILLIST_TEMPLATE_DETAILS = 'GET_NETWORKDETAILLIST_TEMPLATE_DETAILS';

//Preventative Maintence
export const GET_PREVENTATIVEMAINTENCELIST = 'GET_PREVENTATIVEMAINTENCELIST';
export const GET_CLOSEDPREVENTATIVEMAINTENANCELIST = 'GET_CLOSEDPREVENTATIVEMAINTENANCELIST';
export const GET_PREVENTATIVEMAINTENANCEDETAIL = 'GET_PREVENTATIVEMAINTENANCEDETAIL';
export const GET_PM_FAMILYTYPES = 'GET_PM_FAMILYTYPES';
export const GET_PM_EQUIPMENTS_BY_FAMILYTYPE = 'GET_PM_EQUIPMENTS_BY_FAMILYTYPE';
export const GET_PM_BUILDING_POINTS = 'GET_PM_BUILDING_POINTS';
export const GET_PM_BUILDING_EQUIPMENT_POINTS = 'GET_PM_BUILDING_EQUIPMENT_POINTS';
export const GET_PM_DISCOVERED_BUILDINGS = 'GET_PM_DISCOVERED_BUILDINGS';
export const GET_PM_USAGE_FAMILYTYPES = 'GET_PM_USAGE_FAMILYTYPES';
export const GET_PM_USAGE_EQUIPMENTS_BY_FAMILYTYPE = 'GET_PM_USAGE_EQUIPMENTS_BY_FAMILYTYPE';
export const GET_PM_SERVERTIME = 'GET_PM_SERVERTIME';
export const GET_PM_TEMPLATES = 'GET_PM_TEMPLATES';
export const GET_UNIQUEFILENAME = 'GET_UNIQUEFILENAME';
export const GET_PM_TEMPLATE_DETAILS = 'GET_PM_TEMPLATE_DETAILS';
export const GET_PMSETUPMAILADDRESSES = 'GET_PMSETUPMAILADDRESSES';

//Reports Mangement
export const GET_MANAGEREPORTS_LIST = 'GET_MANAGEREPORTS_LIST';
export const GET_MANAGEREPORTS_SUB_LIST = 'GET_MANAGEREPORTS_SUB_LIST';
export const RUN_REPORT_FILE_LINK = 'RUN_REPORT_FILE_LINK';

// Data Export
export const GET_ALL_BUILDINGS_LIST = 'GET_ALL_BUILDINGS_LIST';
export const GET_ALL_FAMILY_TYPES_LIST = 'GET_ALL_FAMILY_TYPES_LIST';
export const GET_BUILDINGS_FAMILY_TYPES_EQUIPMENT = 'GET_BUILDINGS_FAMILY_TYPES_EQUIPMENT';
export const GET_EQUIPMENT_PROPERTIES_LIST = 'GET_EQUIPMENT_PROPERTIES_LIST';
export const GET_DATALOG_DEFINITIONS_LIST = 'GET_DATALOG_DEFINITIONS_LIST';
export const GET_DATASOURCE_DETAILS = 'GET_DATASOURCE_DETAILS';

//Report Designer
export const GET_REPORT_DEFINITION_SUCESSFULL = 'GET_REPORT_DEFINITION_SUCESSFULL';
export const SAVE_REPORT_SUCCESSFUL = 'SAVE_REPORT_SUCCESSFUL';
export const SAVE_REPORT_FAILED = 'SAVE_REPORT_FAILED';
export const GET_IDENTIFIER_DATA_SUCCESSFUL = 'GET_IDENTIFIER_DATA_SUCCESSFUL';
export const SET_DATASOURCE_SELECTIONS = 'SET_DATASOURCE_SELECTIONS';
export const GET_BUILDINGS_SUCCESSFUL = 'GET_BUILDINGS_SUCCESSFUL';
export const GET_FAMILYTYPES_SUCCESSFUL = 'GET_FAMILYTYPES_SUCCESSFUL';
export const GET_OBJECTS_SUCCESSFUL = 'GET_OBJECTS_SUCCESSFUL';
export const GET_POINTS_SUCCESSFUL = 'GET_POINTS_SUCCESSFUL';
export const GET_DATALOG_SUCCESSFUL = 'GET_DATALOG_SUCCESSFUL';
export const UPDATE_REPORT_IDENTIFIER = 'UPDATE_REPORT_IDENTIFIER';
export const GET_IMAGE_SUCCESSFUL = 'GET_IMAGE_SUCCESSFUL';
export const UPDATE_REPORT_WIDGET = 'UPDATE_REPORT_WIDGET';
export const CREATE_REPORT_WIDGET = 'CREATE_REPORT_WIDGET';
export const DELETE_REPORT_WIDGET = 'DELETE_REPORT_WIDGET';
export const CREATE_REPORT_DEFINITION = 'CREATE_REPORT_DEFINITION';
export const UPDATE_REPORT_OPTIONS = 'UPDATE_REPORT_OPTIONS';
export const GET_IMAGE_PATH = 'GET_IMAGE_PATH';

//New Facility Login
export const GET_EMPLOYEE_DETAILS='GET_EMPLOYEE_DETAILS';
export const GET_EMPLOYEE_MYREQUESTS='GET_EMPLOYEE_MYREQUESTS';
export const GET_EMPLOYEE_ALLREQUESTS='GET_EMPLOYEE_ALLREQUESTS';
export const GET_EMPLOYEE_TENANT_DETAILS = 'GET_EMPLOYEE_TENANT_DETAILS';
export const GET_EMPLOYEE_TENANT_ORIGIN = 'GET_EMPLOYEE_TENANT_ORIGIN';

//ASU - Billing Invoices
export const GET_ASU_CAMPUS_INVOICES = 'GET_ASU_CAMPUS_INVOICES';
export const GET_CAMPUS_MONTHLYCHARGES = 'GET_CAMPUS_MONTHLYCHARGES';
export const GET_ASU_CAMPUS_FILTERS = 'GET_ASU_CAMPUS_FILTERS';
export const GET_CAMPUS_BUILDING_INVOICE_BUILDINGID = 'GET_CAMPUS_BUILDING_INVOICE_BUILDINGID';
export const GET_BILLING_CALCULATION = 'GET_BILLING_CALCULATION';

//Reports Schedule
export const GET_SCHEDULES_RECURRENCE_LIST = 'GET_SCHEDULES_RECURRENCE_LIST';
export const GET_SCHEDULES_REPORT_LIST = 'GET_SCHEDULES_REPORT_LIST';
export const GET_SCHEDULES_MAIL_LIST = 'GET_SCHEDULES_MAIL_LIST';
export const SELECTED_REPORT_ID = 'SELECTED_REPORT_ID';

//Left Navigation
// export const GET_ROOTNODE_SUCCESSFULL = 'GET_ROOTNODE_SUCCESSFULL';
// export const GET_CHILDNODE_SUCCESSFULL = 'GET_CHILDNODE_SUCCESSFULL';